import React from 'react'
import {config} from "../constants";

export default class CustomImage extends React.Component {

    constructor() {
        super()
        this.state = {failed: false}
        this.fallback = () => {
            this.setState({failed: true})
        }
    }

    render() {

        let {src, key, className, emptyAvatar} = this.props;

        let imageSrc = src ? src : "none";

        let externalSrc =
            imageSrc === "none"
                ? emptyAvatar
                : (
                    imageSrc.includes("httpsss")
                        ? imageSrc
                        : config.API_URL + "external-http-image?imageUrl=" + src)

        if (this.state.failed) {
            return <img className={className} src={emptyAvatar} key={key} alt={""}/>
        } else {
            return <img className={className} src={externalSrc} onError={this.fallback} key={src} alt={""}/>
        }
    }
}